import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import classNames from 'classnames';
import Overlay from 'bootstrap/Overlay';
import Popover from 'bootstrap/Popover';
import RoleHelper from 'shared/lib/role';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import PopoverStore from 'shared/flux/stores/PopoverStore';
import PopoverActions from 'shared/flux/actions/PopoverActions';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import DurationPicker from 'shared/components/pickers/durationPicker.jsx';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import DurationMuteIcon from 'main/components/show/cuesheet/durationMuteIcon.jsx';
import DurationSuppressionIcon from 'main/components/show/cuesheet/durationSuppressionIcon.jsx';
import TimeInfoIcon from './timeInfoIcon.jsx';

/**
 * Popover-wrapped duration picker
 */
const CuesheetDurationPickerPopover = React.createClass({
  mixins: [Reflux.connect(PopoverStore, 'popoverVisibility'), PureRenderMixin],

  displayName: 'DurationPickerPopover',

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  propTypes: {
    className: React.PropTypes.string,
    rowIndex: React.PropTypes.number.isRequired,
    value: React.PropTypes.number.isRequired, // Used to initialize state
    onChange: React.PropTypes.func.isRequired,
    hoverable: React.PropTypes.bool,
    showSuppressionToggle: React.PropTypes.bool,
    isSuppressed: React.PropTypes.bool,
    onSuppressionChanged: React.PropTypes.func,
    showRunTimeSuppressionToggle: React.PropTypes.bool,
    isRunTimeSuppressed: React.PropTypes.bool,
    onRunTimeSuppressionChanged: React.PropTypes.func,
    showResetButton: React.PropTypes.bool,
    onResetClicked: React.PropTypes.func,
    buttonsComponents: React.PropTypes.element,
    pickerType: React.PropTypes.string,
    title: React.PropTypes.string,
  },

  getDefaultProps() {
    return {
      hoverable: false,
      isSuppressed: false,
      isRunTimeSuppressed: false,
      className: 'input-duration-wrapper',
      value: 0,
    };
  },

  getInitialState() {
    return {
      value: null,
      valueChanged: false,
    };
  },

  render() {
    return (
      <div className={this.props.className}>
        {this._getDisplayNode()}
        {this._getDurationPickerNode()}
      </div>
    );
  },

  componentWillReceiveProps(nextProps) {
    // We use valueChanged here to determine if the value has not changed then,
    // set what the current value is as default, this fixes changes made but not saved (when using escape key)
    // getting persisted when re-opening the popover
    if (this.state.value !== nextProps.value && !this.state.valueChanged) {
      this.setState({ value: nextProps.value });
    }
  },

  _getDisplayNode() {
    return <div ref="target">{this.props.displayNode}</div>;
  },

  _getValue() {
    let val = this.state.value;

    if (val === null) val = this.props.value;

    return val;
  },

  _hasAdmin() {
    const params = this.context.router.state.params;
    const { teamId, eventId } = params;

    return RoleHelper.hasEventAdminRole(this.props.user, teamId, eventId);
  },

  _getPopoverId() {
    return EditableCellTypes.ItemDuration + this.props.rowIndex;
  },

  _getDurationPickerNode() {
    const { simple } = this.props;

    let value = this._getValue();

    // const pickerTypeClass = 'duration-cell';

    return (
      <Overlay
        rootClose
        container={document.body}
        show={this.state.popoverVisibility.get(this._getPopoverId())}
        placement={'left'}
        target={() => ReactDOM.findDOMNode(this.refs.target)}
        onHide={() => this._handleClose()}
        animation={false}
      >
        <Popover
          id={'popover-duration-picker-' + this._getPopoverId()}
          className={classNames('duration-picker-popover duration-cell', {
            'simple-cell': simple,
          })}
        >
          <div
            onKeyDown={(e) => {
              // keyCode 27 - esc key
              if (e.keyCode === 27) {
                this._handleClose(true);
              }
            }}
          >
            <CuesheetDurationPicker
              {...this.props}
              value={value}
              onResetClicked={this._handleReset}
              onClose={this._handleClose}
              onChange={this._handleChange}
              onTab={this._handleClose}
              valueChanged={this.state.valueChanged}
            />
          </div>
        </Popover>
      </Overlay>
    );
  },

  _handleChange(value) {
    this.setState({ value, valueChanged: true });
  },

  _handleReset() {
    this.setState({ value: 0, valueChanged: true }, () => {
      this._handleClose(false);
    });
  },

  /**
   * Closing and changing input values are not the same, as other time pickers
   * need to on certain key presses only close and save modal to api
   * and some change the value but on an escape key press don't want to save value to api
   *
   * @param {bool} escaped determines if user used escape key to close modal
   */
  _handleClose(escaped) {
    PopoverActions.hide(this._getPopoverId());

    /**
     * @param escape Used to fix issue where escape persists value of changed field
     * when re-opening picker
     */
    if (escaped) {
      const { value } = this.props;

      this.setState({ value });
    } else {
      CuesheetCellActions.saveItemTimeFields(this.props.rowIndex, {
        durationInSeconds: this._getValue(),
      });
    }
  },
});

/**
 * The actual duration picker
 *
 */
const CuesheetDurationPicker = React.createClass({
  displayName: 'DurationPicker',

  propTypes: {
    value: React.PropTypes.number.isRequired,
    showSuppressionToggle: React.PropTypes.bool,
    isSuppressed: React.PropTypes.bool,
    onSuppressionChanged: React.PropTypes.func,
    onRunTimeSuppressionChanged: React.PropTypes.func,
    onClose: React.PropTypes.func,
    showResetButton: React.PropTypes.bool,
    onResetClicked: React.PropTypes.func,
    buttonsComponent: React.PropTypes.element,
    hasShowcaller: React.PropTypes.bool,
    mobile: React.PropTypes.bool,
  },

  getDefaultProps() {
    return {
      pickerType: 'duration',
    };
  },

  getInitialState() {
    return {
      originalValue: this.props.value,
    };
  },

  render() {
    const {
      value,
      onChange,
      onTab,
      onClose,
      mobile,
      displayType,
      durationText,
    } = this.props;

    // const positiveValue = value > 0 ? value : 0;

    const originalValueText = (
      <span className="original-duration-value">Was: {durationText}</span>
    );

    return (
      <div className="duration-picker">
        <div className="text-center">
          <div className="picker-body">
            <DurationPicker
              {...{ displayType, mobile, value, onChange, onClose, onTab }}
            />
            {mobile ? this._getResetButtonNode() : null}
            <div className="duration-icon-wrapper">
              {this._getSuppressionToggleNode()}
              {this._getItemRunTimeSuppressionToggleNode()}
              {this._getToggleDurationClockNode()}
              {!mobile ? this._getResetButtonNode() : null}
              {this._getButtonsNode()}
            </div>
            {mobile ? null : <br />}
            {!mobile ? originalValueText : null} <TimeInfoIcon />
          </div>
        </div>
      </div>
    );
  },

  _getSuppressionToggleNode() {
    const {
      isSuppressed,
      onSuppressionChanged,
      showSuppressionToggle,
    } = this.props;

    if (!showSuppressionToggle) return null;

    return (
      <DurationMuteIcon
        withTooltip
        isSuppressed={isSuppressed}
        onChange={onSuppressionChanged}
      />
    );
  },

  _getItemRunTimeSuppressionToggleNode() {
    const {
      isRunTimeSuppressed,
      onRunTimeSuppressionChanged,
      showRunTimeSuppressionToggle,
    } = this.props;

    if (!showRunTimeSuppressionToggle) return null;

    return (
      <DurationSuppressionIcon
        onChange={onRunTimeSuppressionChanged}
        isRunTimeSuppressed={isRunTimeSuppressed}
        withTooltip
      />
    );
  },

  _getToggleDurationClockNode() {
    const { mobile, displayDurationClock } = this.props;

    if (mobile) return null;

    const durationIcon = displayDurationClock ? 'eye' : 'eye-slash';

    return (
      <div className="duration-picker-suppress-toggle">
        <Icon
          name={durationIcon}
          onClick={() => this._toggleDisplayDurationClock()}
        />
      </div>
    );
  },

  _toggleDisplayDurationClock() {
    const currentValue = this.props.displayDurationClock;

    const changes = {
      displayDurationClock: !currentValue,
      runTimeClockSuppressed: currentValue,
      durationSuppressed: currentValue,
    };

    if (currentValue === true) PopoverActions.hide(this.props.id);

    CuesheetCellActions.saveItemTimeFields(this.props.rowIndex, changes);
  },

  _getResetButtonNode() {
    if (!this.props.showResetButton) return null;

    return (
      <div className="duration-picker-reset-button">
        <Icon onClick={() => this.props.onResetClicked()} name="undo" />
      </div>
    );
  },

  _getButtonsNode() {
    if (!this.props.buttonsComponent) return null;

    return <div>{this.props.buttonsComponent}</div>;
  },
});

export default CuesheetDurationPickerPopover;
